<script>import { twMerge } from 'tailwind-merge';
import { get_current_component } from 'svelte/internal';
import { forwardEventsBuilder, useActions } from '../../actions';
export let use = [];
import { exclude } from '../../utils/exclude';
const forwardEvents = forwardEventsBuilder(get_current_component());
export let id;
const defaultClass = 'table-row h-12 max-h-[3rem] cursor-pointer hover:bg-hover hover:bg-opacity-5 bg-surface stwui-table-body-row';
$: finalClass = twMerge(defaultClass, $$props.class);
</script>

{#key id}
	<tr
		{id}
		class={finalClass}
		style="height: 48px; max-height: 48px;{$$props.style}"
		use:useActions={use}
		use:forwardEvents
		{...exclude($$props, ['use', 'class', 'style'])}
	>
		<slot />
	</tr>
{/key}
